module.exports = {"full_name":"Full name","enter_full_name":"Enter full name","first_name_hint":"Start with first name","last_name_hint":"Continue with last name"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/en/fullName.json
// module id = 642
// module chunks = 247 1452